import React from "react"
import { Box, Typography } from "@mui/material"


export default function KeyStat(props) {
    const stat = props.stat
    const label = props.label
    const variant = props.variant
    const color = props.color

    return (
        <Box display="flex">
            <Typography variant={variant} color={color} sx={{ fontWeight: 900 }}>
                {stat}
            </Typography>
            <Typography variant={variant} color={color} sx={{ fontWeight: 500, marginLeft: "6px" }} >
                {label}
            </Typography>
        </Box>
    )
}